import { createContext } from 'react';
var DatePickerContext = /*#__PURE__*/createContext();
export { DatePickerContext };